export const TableDataType = {
  SELLING_AGENT: 'Selling',
  LISTING_AGENT: 'Listing',
  SELLER: 'Seller',
};

export const TableDataTypeToNameMap = {
  [TableDataType.SELLING_AGENT]: 'selling agent',
  [TableDataType.SELLING_AGENT]: 'listing agent',
  [TableDataType.SELLER]: 'seller',
};

export const TableDataTypeToSideDataNameMap = {
  [TableDataType.SELLING_AGENT]: 'sellingAgents',
  [TableDataType.LISTING_AGENT]: 'listingAgents',
  [TableDataType.SELLER]: 'sellers',
};

const SellingAgentTableColumnId = {
  AGENT_NAME: 'agentName',
  AGENT_STATE_LICENSE_NUMBER: 'agentStateLicenseNumber',
  AGENT_STATE_LICENSE_ID: 'agentStateLicenseId',
  EMAIL: 'email',
  PHONE: 'phone',
};

const ListingAgentTableColumnId = {
  AGENT_NAME: 'agentName',
  AGENT_STATE_LICENSE_NUMBER: 'agentStateLicenseNumber',
  AGENT_STATE_LICENSE_ID: 'agentStateLicenseId',
  EMAIL: 'email',
  PHONE: 'phone',
};

const SellerTableColumnId = {
  SELLER_NAME: 'sellerName',
  EMAIL: 'email',
  PHONE: 'phone',
  FULL_ADDRESS: 'fullAddress',
  COMPANY_NAME: 'companyName',
};

export const defaultSellingAgentSortOrder = {
  direction: 'desc',
  id: SellingAgentTableColumnId.AGENT_NAME,
};

export const defaultListingAgentSortOrder = {
  direction: 'desc',
  id: ListingAgentTableColumnId.AGENT_NAME,
};

export const defaultSellerSortOrder = {
  direction: 'desc',
  id: SellerTableColumnId.SELLER_NAME,
};

export const agentAndSellerModifiedFieldsToExclude = [
  'loanUnderwritingAgentId',
  'loanId',
  'loanUnderwritingSellerId',
];

export const agentsAndSellersPendingChangesSectionKey = ['agentsAndSellersPendingChanges'];

export const MAX_AGENTS_COUNT = 2;

// CRM tag applied to realtor-agent contacts so they can be surfaced in the picker.
export const AGENT_TAG_NAME = 'Realtor Agent';

// Lifecycle stage for an auto-saved agent CRM contact (mirrors NewContactDrawer's default).
export const AGENT_CONTACT_LIFECYCLE_STAGE = 'Lead';
